var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.from?.name)+" "),(_vm.pickupPoint)?_c('span',{staticStyle:{"font-size":"80%"}},[_vm._v("("+_vm._s(_vm.pickupPoint.name)+")")]):_vm._e(),_vm._v(" to "+_vm._s(_vm.to?.name)+" "),(_vm.dropoffPoint)?_c('span',{staticStyle:{"font-size":"80%"}},[_vm._v("("+_vm._s(_vm.dropoffPoint.name)+")")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }